import React from "react";
import { useSearchParams } from "react-router";
import CustomersTable from "./CustomersTable";
import UsersTable from "./UsersTable";
import SalesforceOrgsTable from "./SalesforceOrgsTable";

export default function Customers() {
    const [searchParams, setSearchParams] = useSearchParams();
    const view = searchParams.get("view"); // users | salesforce | null
    const tenantId = searchParams.get("tenantId");

    //  MAIN LOGIC
    if (view === "users" && tenantId) {
        return (
            <UsersTable
                tenantId={tenantId}
                onBack={() => {
                    // eslint-disable-next-line no-undef
                    const sp = new URLSearchParams();
                    sp.set("page", "manageCustomers");
                    setSearchParams(sp);
                }}
                
            />
        );
    }
    if (view === "salesforce" && tenantId) {
        return (
            <SalesforceOrgsTable
                tenantId={tenantId}
                onBack={() => {
                    // eslint-disable-next-line no-undef
                    const sp = new URLSearchParams();
                    sp.set("page", "manageCustomers");
                    setSearchParams(sp);
                }}
            />
        );
    }
    // Default → Customers List
    return (
        <CustomersTable
            onNavigate={(type, tenant) => {
                // eslint-disable-next-line no-undef
                const sp = new URLSearchParams();
                sp.set("page", "manageCustomers");
                sp.set("tenantId", tenant?.tenantId);
                if (type === "users") {
                    sp.set("view", "users");
                }
                if (type === "salesforce") {
                    sp.set("view", "salesforce");
                }
                setSearchParams(sp);
            }}
        />
    );
}
